(function() {

  angular
  .module('meanApp')
  .service('modelManager', modelManager);

    modelManager.$inject = ['$http', 'httpAuth', '$q'];
    function modelManager ($http, httpAuth, $q) {
    var makeId = function() {
        var text = "",
        possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for( var i=0; i < 5; i++ )
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    };

    var modelManager = function(Model) {
    	return {
    		_defaultIdAttribute : '_id',
    		_pool: {},//list all the current users loaded

	        //si l'instance est deja chargee on la redonne, sinon on crée un nouvelle instance
	        //peut etre factorisée mais il doit y avoir un lien avec le module du model pour créer une nouvelle instance
	        _retrieveInstance: function(id, data, forceCall) {
                var instance = this._pool[id],
                forceCall = (typeof forceCall === 'undefined') ? false : forceCall;
                
	            if (instance && !forceCall) {
	                instance.setData(data);
	            } else {
	                instance = new Model(data);
	                this._pool[id] = instance;
	            }
	            return instance;
	        },

	        //TODO must be working and the list should get refreshed since the value disappears
	        _removeInstance: function(id) {
	            //delete just remove one attribute. have to do it for all attributes...
	            var instance = this._pool[id], keys;
	            if (instance) {
	                keys = Object.keys(instance);
	                for (var i=0, l=keys.length; i<l; i++) {
	                    delete instance[keys[i]]; //delete every reference
	                }
	            }
	            delete this._pool[id];//TODO check this works
	        },

	        _search: function(id) {
	            return this._pool[id];
	        },

	        _load: function(id, deferred, forceCall) {
	            var scope = this;
	            httpAuth.get('/api/' + Model.APIPath + '/' + id)
                .success(function(data) {
                    var instance = scope._retrieveInstance(data[Model.idAttribute || scope._defaultIdAttribute], data, forceCall);

                    //TODO here get other model managers and load them with data
                    deferred.resolve(instance);
                })
                .error(function() {
                    console.log('user collection get GOT rejected');
                    deferred.reject();
                });
	        },

	        //implement something to delete user
	        'delete' : function(id) {
	            var deferred = $q.defer(),
	            instance = this._search(id);

	            httpAuth.delete('/api/' + Model.APIPath + '/' + id)
	            .success(function() {
	                if (instance) {
	                    this._removeInstance(id);
	                }
	                //return something ??
	                deferred.resolve();
	            }.bind(this))
	            .error(function(err) {
	                deferred.reject(err);
	            });

	            return deferred.promise;
	        },

	        /* Public Methods */
	        /* Use this function in order to get a book instance by it's id */
	        get: function(id, forceCall, needsComplete) {
                console.log('model manager the call is forced : ', forceCall);
                forceCall = (typeof forceCall === 'undefined') ? false : forceCall;

	            var deferred = $q.defer(),
                instance = this._search(id);

                if(needsComplete && instance && instance.isModelComplete) {
                    forceCall = !instance.isModelComplete();
                }

	            if (instance && !forceCall) {
	                deferred.resolve(instance);
	            } else {
	                this._load(id, deferred, forceCall);
	            }
	            return deferred.promise;
            },
            
            //to be overrided
            isModelComplete : function() {
                return true;
            },

	        getAll: function() {
                var deferred = $q.defer(),
                scope = this;

                httpAuth.get('/api/' + Model.APIPath + '/')
                .success(function(resultArray) {
                    var array = [],
                        result = {};
                    resultArray.forEach(function(itemArray) {
                        var instance = scope._retrieveInstance(itemArray[Model.idAttribute || scope._defaultIdAttribute], itemArray);
                        array.push(instance);
                    });

                    result.collection = array;
                    deferred.resolve(result);
                })
                .error(function(err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            },
       
	        set: function(data) {
	            var scope = this,
	            id = data[Model.idAttribute || scope._defaultIdAttribute] || makeId(),
	            instance = this._search(id);
	            if (instance) {
	                instance.setData(data);
	            } else {
	                instance = scope._retrieveInstance(id, data);
	            }
	            return instance;
	        }
    	}
    };
        
    return {
    	init: function(Model) {
    		return modelManager(Model);
    	}
    };
  }

})();